import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { getProjectHeatmapSettings } from "slices/projectHeatmapSettings/projectHeatmapSettingsSlice";

export interface SelectedQuestionsState {
  selectedQuestions: string[];
}

const initialState = {
  selectedQuestions: [],
} as SelectedQuestionsState;

const selectedQuestionsSlice = createSlice({
  name: "selectedQuestions",
  initialState: initialState,
  reducers: {
    resetSelectedQuestions: () => initialState,
    setQuestions: (state, action: PayloadAction<string[]>) => {
      state.selectedQuestions = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getProjectHeatmapSettings.fulfilled, (state, action) => {
      const selectedQuestions = action.payload.projectSettings.selectedQuestions;
      return selectedQuestions ?? initialState;
    });
  },
});

export const { setQuestions, resetSelectedQuestions } = selectedQuestionsSlice.actions;

export default selectedQuestionsSlice.reducer;
